<main id="main-content" class="main-content">
  <h2 class="form-header">Signatures & Certifications:</h2>
  @for (forest of report().forests; track forest) {
    <mat-card>
      <div class="title">{{ forest.forest_name }}
        @if (forest.signature != null) {
          <mat-chip class="chip-4">SIGN & CERTIFIED</mat-chip>
        }
        @if (forest.signature == null) {
          <mat-chip class="chip-high">NEEDS SIGNATURE</mat-chip>
        }
      </div>
      <div class="whole-line">
        <div class="quarter-div">
          <p class="data-title">Signed and Certified on</p>
          <p class="data-info">
            {{ forest.signature?.created_on | date:"MM/dd/yyyy" | empty_check }}
          </p>
        </div>
        <div class="quarter-div">
          <p class="data-title">Signed By</p>
          <p class="data-info">{{ forest.signature?.name ?? "--" }}</p>
        </div>
        @if (forest.signature?.signing_for !== "Myself") {
        <div class="quarter-div">
          <p class="data-title">Signed For</p>
          <p class="data-info">{{ forest.signature?.signing_for ?? "--" }}</p>
        </div>
        }
        <div class="quarter-div">
          <p class="data-title">Title</p>
          <p class="data-info">{{ forest.signature?.title ?? "--" }}</p>
        </div>
      </div>
    </mat-card>
  }
</main>